import { render } from "./ShareApp.vue?vue&type=template&id=1a309934"
import script from "./ShareApp.vue?vue&type=script&lang=js"
export * from "./ShareApp.vue?vue&type=script&lang=js"

import "./ShareApp.vue?vue&type=style&index=0&id=1a309934&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__